import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: i * 0.05 },
  }),
};

export default function Manifesto() {
  const { t } = useLang();
  const CHAPTERS = [
    { no: "01", title: t("manifesto.c1t"), body: t("manifesto.c1b") },
    { no: "02", title: t("manifesto.c2t"), body: t("manifesto.c2b") },
    { no: "03", title: t("manifesto.c3t"), body: t("manifesto.c3b") },
    { no: "04", title: t("manifesto.c4t"), body: t("manifesto.c4b") },
  ];
  return (
    <section
      id="manifesto"
      data-testid="section-manifesto"
      className="mx-auto max-w-[1400px] px-6 py-28 md:px-10 md:py-40"
    >
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="mb-16 flex items-center gap-3"
      >
        <span className="h-px w-10 bg-[#B85D43]" />
        <span className="overline text-[#B85D43]">{t("manifesto.overline")}</span>
      </motion.div>

      <div className="grid grid-cols-1 gap-y-20 md:gap-y-28">
        {CHAPTERS.map((c, i) => (
          <motion.article
            key={c.no}
            custom={i}
            variants={reveal}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.4 }}
            className="grid grid-cols-1 items-start gap-6 border-t border-[#3A4536]/15 pt-8 md:grid-cols-12 md:gap-10"
          >
            <div className="md:col-span-3">
              <span className="font-serif-display text-5xl font-light text-[#B85D43] md:text-6xl">
                {c.no}
              </span>
            </div>
            <h3 className="font-serif-display text-4xl font-light leading-tight text-[#1A2118] md:col-span-4 md:text-5xl">
              {c.title}
            </h3>
            <p className="max-w-xl text-base leading-relaxed text-[#3A4536] md:col-span-5">
              {c.body}
            </p>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
